var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _g2, _g3, _rect18, _rect19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108.702,
    height: 95.643,
    viewBox: "0 0 108.702 95.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1519",
    "data-name": "Rectangle 1519",
    width: 108.702,
    height: 95.643,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1511",
    "data-name": "Rectangle 1511",
    width: 13.874,
    height: 5.902,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1510",
    "data-name": "Rectangle 1510",
    width: 13.873,
    height: 5.902,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1513",
    "data-name": "Rectangle 1513",
    width: 11.777,
    height: 71.007,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1512",
    "data-name": "Rectangle 1512",
    width: 11.777,
    height: 71.006,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1515",
    "data-name": "Rectangle 1515",
    width: 4.283,
    height: 18.466,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1514",
    "data-name": "Rectangle 1514",
    width: 4.282,
    height: 18.466,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1692",
    "data-name": "Group 1692",
    transform: "translate(-42.602 -24.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(42.602 24.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M141.827.009V44.678L123.366.009H106.377v71h11.789V19.058L140.193,71.01h13.422v-71Z",
    transform: "translate(-44.913 -0.004)",
    fill: "#0d92d4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M32.657.009V28.686H15.7V.009H0v71H15.7V41.725H32.657V71.01H46.531v-71Z",
    transform: "translate(0 -0.004)",
    fill: "#87bb2d"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1492",
    "data-name": "Rectangle 1492",
    width: 1.108,
    height: 2.409,
    transform: "translate(53.419 1.954)",
    fill: "#c7851b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1493",
    "data-name": "Rectangle 1493",
    width: 1.108,
    height: 2.412,
    transform: "translate(53.419 5.996)",
    fill: "#c7851b"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1494",
    "data-name": "Rectangle 1494",
    width: 1.108,
    height: 2.409,
    transform: "translate(53.419 10.041)",
    fill: "#c7851b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1495",
    "data-name": "Rectangle 1495",
    width: 1.108,
    height: 2.412,
    transform: "translate(53.419 14.082)",
    fill: "#c7851b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1496",
    "data-name": "Rectangle 1496",
    width: 1.108,
    height: 2.409,
    transform: "translate(53.419 18.128)",
    fill: "#c7851b"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1497",
    "data-name": "Rectangle 1497",
    width: 1.108,
    height: 2.405,
    transform: "translate(53.419 22.174)",
    fill: "#c7851b"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1498",
    "data-name": "Rectangle 1498",
    width: 1.108,
    height: 2.407,
    transform: "translate(53.419 26.216)",
    fill: "#c7851b"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1499",
    "data-name": "Rectangle 1499",
    width: 1.108,
    height: 2.408,
    transform: "translate(53.419 30.256)",
    fill: "#c7851b"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1500",
    "data-name": "Rectangle 1500",
    width: 1.108,
    height: 2.412,
    transform: "translate(53.419 34.298)",
    fill: "#c7851b"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1501",
    "data-name": "Rectangle 1501",
    width: 1.108,
    height: 2.405,
    transform: "translate(53.419 38.346)",
    fill: "#c7851b"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1502",
    "data-name": "Rectangle 1502",
    width: 1.108,
    height: 2.407,
    transform: "translate(53.419 42.39)",
    fill: "#c7851b"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1503",
    "data-name": "Rectangle 1503",
    width: 1.108,
    height: 2.407,
    transform: "translate(53.419 46.431)",
    fill: "#c7851b"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1504",
    "data-name": "Rectangle 1504",
    width: 1.108,
    height: 2.409,
    transform: "translate(53.419 50.475)",
    fill: "#c7851b"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1505",
    "data-name": "Rectangle 1505",
    width: 1.108,
    height: 2.407,
    transform: "translate(53.419 54.518)",
    fill: "#c7851b"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1506",
    "data-name": "Rectangle 1506",
    width: 1.108,
    height: 2.408,
    transform: "translate(53.419 58.559)",
    fill: "#c7851b"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1507",
    "data-name": "Rectangle 1507",
    width: 1.108,
    height: 2.409,
    transform: "translate(53.419 62.603)",
    fill: "#c7851b"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1508",
    "data-name": "Rectangle 1508",
    width: 1.108,
    height: 2.409,
    transform: "translate(53.419 66.646)",
    fill: "#c7851b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M6.854,140.709h-.9v-3.422H2.623v3.422h-.9v-7.187h.9V136.5H5.952v-2.976h.9Z",
    transform: "translate(-0.726 -56.375)",
    fill: "#c7851b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M27.689,139.918v.791h-4.65v-7.187h4.55v.789H23.94V136.6h2.895v.733H23.94v2.586Z",
    transform: "translate(-9.727 -56.375)",
    fill: "#c7851b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M46.8,140.71h-.917l-.726-2.1H42.5l-.645,2.1H41.1l2.334-7.186h1.017Zm-1.833-2.775-1.112-3.45-1.112,3.45Z",
    transform: "translate(-17.353 -56.375)",
    fill: "#c7851b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M66.163,139.918v.791H61.924v-7.187h.919v6.4Z",
    transform: "translate(-26.145 -56.375)",
    fill: "#c7851b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M80.492,140.709h-.9v-6.4H77.534v-.791h5.022v.791H80.492Z",
    transform: "translate(-32.736 -56.375)",
    fill: "#c7851b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M102.418,140.709h-.9v-3.422H98.185v3.422h-.9v-7.187h.9V136.5h3.329v-2.976h.9Z",
    transform: "translate(-41.073 -56.375)",
    fill: "#c7851b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    clipPath: "url(#clip-path)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M122.325,140.709h-.874l-3.716-6.264.012.477c.01.176.013.326.013.452v5.336h-.726v-7.187h1.127l3.473,5.859-.007-.5c-.007-.2-.013-.37-.013-.523v-4.836h.711Z",
    transform: "translate(-49.413 -56.374)",
    fill: "#c7851b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M140.781,140.749a2.514,2.514,0,0,1-2.161-1.074,4.44,4.44,0,0,1-.774-2.647,4.335,4.335,0,0,1,.811-2.7,2.7,2.7,0,0,1,4.286-.016,4.192,4.192,0,0,1,.8,2.634,4.6,4.6,0,0,1-.778,2.661,2.507,2.507,0,0,1-2.188,1.137m.02-.733a1.638,1.638,0,0,0,1.469-.859,4.115,4.115,0,0,0,.537-2.212,3.7,3.7,0,0,0-.552-2.167A1.711,1.711,0,0,0,140.8,134a1.67,1.67,0,0,0-1.465.839,3.952,3.952,0,0,0-.545,2.19,3.847,3.847,0,0,0,.55,2.157,1.675,1.675,0,0,0,1.464.826",
    transform: "translate(-58.2 -56.267)",
    fill: "#c7851b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M163.951,133.523l-2.423,7.187h-.866l-2.426-7.187h.947l2,5.928,1.981-5.928Z",
    transform: "translate(-66.809 -56.375)",
    fill: "#c7851b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M180.852,140.749a2.524,2.524,0,0,1-2.162-1.074,4.454,4.454,0,0,1-.768-2.647,4.327,4.327,0,0,1,.809-2.7,2.7,2.7,0,0,1,4.283-.016,4.18,4.18,0,0,1,.809,2.634,4.571,4.571,0,0,1-.781,2.661,2.514,2.514,0,0,1-2.19,1.137m.02-.733a1.643,1.643,0,0,0,1.474-.859,4.136,4.136,0,0,0,.532-2.212,3.683,3.683,0,0,0-.552-2.167A1.7,1.7,0,0,0,180.87,134a1.676,1.676,0,0,0-1.467.839,4,4,0,0,0-.54,2.19,3.885,3.885,0,0,0,.545,2.157,1.681,1.681,0,0,0,1.464.826",
    transform: "translate(-75.12 -56.267)",
    fill: "#c7851b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M44.92,160.231h-.57l.341-2.171H42.577l-.343,2.171h-.57l.721-4.56h.571l-.3,1.888h2.117l.3-1.888h.571Z",
    transform: "translate(-17.591 -65.726)",
    fill: "#c7851b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M51.555,160.024l.471.1a1.732,1.732,0,0,1-.636.714,1.7,1.7,0,0,1-.956.283,1.193,1.193,0,0,1-1.041-.486,1.664,1.664,0,0,1-.227-1.273,2.231,2.231,0,0,1,.651-1.306,1.7,1.7,0,0,1,1.192-.5,1.138,1.138,0,0,1,.993.459,1.822,1.822,0,0,1,.194,1.37H49.744a1.179,1.179,0,0,0,.162,1.033.884.884,0,0,0,.634.266,1.128,1.128,0,0,0,1.014-.664M51.686,159a1.449,1.449,0,0,0-.014-.5.684.684,0,0,0-.711-.53,1.032,1.032,0,0,0-.7.278,1.409,1.409,0,0,0-.426.757Z",
    transform: "translate(-20.745 -66.524)",
    fill: "#c7851b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M57.87,161.03h-.514a5.388,5.388,0,0,1,.037-.608,1.465,1.465,0,0,1-1.3.7,1.024,1.024,0,0,1-.822-.3.844.844,0,0,1-.187-.725,1.213,1.213,0,0,1,.567-.84,2.769,2.769,0,0,1,1.525-.331c.092,0,.243,0,.446.016a2.081,2.081,0,0,0,.031-.583.434.434,0,0,0-.215-.285,1.059,1.059,0,0,0-.514-.1.968.968,0,0,0-1.025.606l-.47-.081c.218-.625.762-.933,1.637-.933a1.152,1.152,0,0,1,.941.307,1.407,1.407,0,0,1,.124,1.072l-.23,1.433a2.841,2.841,0,0,0-.032.652m-.31-1.685c-.21-.014-.37-.021-.484-.021a2.094,2.094,0,0,0-1,.2.8.8,0,0,0-.44.6.483.483,0,0,0,.12.419.641.641,0,0,0,.51.176,1.153,1.153,0,0,0,.833-.347,1.363,1.363,0,0,0,.433-.811,2.057,2.057,0,0,0,.025-.217",
    transform: "translate(-23.251 -66.526)",
    fill: "#c7851b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M62.139,160.232h-.523l.719-4.558h.525Z",
    transform: "translate(-26.015 -65.728)",
    fill: "#c7851b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M65.878,160.088l-.065.412a3.474,3.474,0,0,1-.487.039c-.65,0-.925-.34-.816-1.023l.321-2.034h-.6l.062-.41h.6l.16-.849.494-.046-.143.9h.755l-.063.41h-.757l-.333,2.121q-.084.521.461.521a2.51,2.51,0,0,0,.41-.035",
    transform: "translate(-27.121 -65.939)",
    fill: "#c7851b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M70.621,160.233H70.1l.324-2.046a2.315,2.315,0,0,0,.042-.542.454.454,0,0,0-.166-.31.52.52,0,0,0-.366-.134,1.015,1.015,0,0,0-.731.329,1.6,1.6,0,0,0-.41.889l-.287,1.815h-.525l.722-4.558h.523l-.283,1.8a1.35,1.35,0,0,1,1.134-.711,1.051,1.051,0,0,1,.507.117.678.678,0,0,1,.309.307,1.075,1.075,0,0,1,.111.376,2.87,2.87,0,0,1-.053.62Z",
    transform: "translate(-28.701 -65.728)",
    fill: "#c7851b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M76.529,159.849l.46.083a1.842,1.842,0,0,1-.583.873,1.4,1.4,0,0,1-.912.321,1.03,1.03,0,0,1-.981-.518,1.906,1.906,0,0,1-.164-1.254,2.418,2.418,0,0,1,.588-1.282,1.473,1.473,0,0,1,1.131-.509,1.049,1.049,0,0,1,.834.328,1.274,1.274,0,0,1,.273.852l-.486.088c0-.556-.228-.834-.674-.834a.884.884,0,0,0-.725.37,1.982,1.982,0,0,0-.384.956,1.689,1.689,0,0,0,.07,1.007.616.616,0,0,0,.6.359c.431,0,.752-.283.956-.841",
    transform: "translate(-31.376 -66.525)",
    fill: "#c7851b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M82.4,161.03h-.516a4.614,4.614,0,0,1,.036-.608,1.463,1.463,0,0,1-1.3.7,1.014,1.014,0,0,1-.821-.3.852.852,0,0,1-.193-.725,1.232,1.232,0,0,1,.565-.84,2.8,2.8,0,0,1,1.53-.331c.092,0,.243,0,.447.016a2.115,2.115,0,0,0,.029-.583.427.427,0,0,0-.22-.285,1.023,1.023,0,0,0-.51-.1.969.969,0,0,0-1.025.606l-.47-.081c.213-.625.759-.933,1.636-.933a1.156,1.156,0,0,1,.942.307,1.413,1.413,0,0,1,.122,1.072l-.225,1.433a2.581,2.581,0,0,0-.034.652m-.31-1.685c-.213-.014-.375-.021-.486-.021a2.08,2.08,0,0,0-1,.2.8.8,0,0,0-.442.6.476.476,0,0,0,.123.419.631.631,0,0,0,.507.176,1.158,1.158,0,0,0,.833-.347,1.369,1.369,0,0,0,.437-.811c.009-.06.016-.131.023-.217",
    transform: "translate(-33.608 -66.526)",
    fill: "#c7851b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M86.671,161.024h-.523l.532-3.373h.46l-.123.789a2.064,2.064,0,0,1,.6-.726,1.05,1.05,0,0,1,.528-.165,2.014,2.014,0,0,1,.209.017l-.084.5h-.106a1.082,1.082,0,0,0-.771.326,1.569,1.569,0,0,0-.441.852Z",
    transform: "translate(-36.373 -66.519)",
    fill: "#c7851b"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M92.412,160.024l.469.1a1.723,1.723,0,0,1-.634.714,1.685,1.685,0,0,1-.953.283,1.189,1.189,0,0,1-1.041-.486,1.644,1.644,0,0,1-.228-1.273,2.213,2.213,0,0,1,.649-1.306,1.7,1.7,0,0,1,1.194-.5,1.136,1.136,0,0,1,.991.459,1.853,1.853,0,0,1,.2,1.37H90.606c-.083.507-.03.856.155,1.033a.889.889,0,0,0,.636.266,1.127,1.127,0,0,0,1.014-.664M92.544,159a1.507,1.507,0,0,0-.014-.5.684.684,0,0,0-.708-.53,1.052,1.052,0,0,0-.709.278,1.439,1.439,0,0,0-.426.757Z",
    transform: "translate(-37.996 -66.524)",
    fill: "#c7851b"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M98.711,158.958l.537-.116a1.063,1.063,0,0,0,1.194.933,1.4,1.4,0,0,0,.852-.232.915.915,0,0,0,.37-.613.5.5,0,0,0-.134-.47.978.978,0,0,0-.44-.246l-.881-.227a2.053,2.053,0,0,1-.543-.215.842.842,0,0,1-.32-.4,1.076,1.076,0,0,1-.058-.611,1.332,1.332,0,0,1,.571-.914,2,2,0,0,1,1.16-.337,1.3,1.3,0,0,1,1.454,1.124l-.543.155a.747.747,0,0,0-.326-.607,1.185,1.185,0,0,0-.679-.206,1.284,1.284,0,0,0-.7.2.769.769,0,0,0-.384.56c-.049.337.16.565.636.685l.82.2c.749.185,1.069.607.966,1.259a1.492,1.492,0,0,1-.6.984,2.029,2.029,0,0,1-1.3.393,1.5,1.5,0,0,1-1.666-1.3",
    transform: "translate(-41.677 -65.659)",
    fill: "#c7851b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M106.965,156.856l-.532,3.375H105.9l.534-3.375Zm.2-1.185-.092.588h-.56l.088-.588Z",
    transform: "translate(-44.714 -65.726)",
    fill: "#c7851b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M113.148,161.031h-.509l.328-2.1a1.842,1.842,0,0,0,.032-.486.465.465,0,0,0-.171-.3.541.541,0,0,0-.37-.139,1.011,1.011,0,0,0-.625.278,1.333,1.333,0,0,0-.41.841l-.3,1.9h-.507l.352-2.222a.724.724,0,0,0-.111-.629.59.59,0,0,0-.419-.181.881.881,0,0,0-.627.285,1.275,1.275,0,0,0-.364.729l-.317,2.019h-.5l.532-3.373h.449l-.1.646a1.407,1.407,0,0,1,1.157-.739.744.744,0,0,1,.578.235.867.867,0,0,1,.237.571,1.385,1.385,0,0,1,1.2-.805.827.827,0,0,1,.572.2.731.731,0,0,1,.264.454,2.59,2.59,0,0,1-.035.717Z",
    transform: "translate(-45.865 -66.526)",
    fill: "#c7851b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M118.369,162.168h-.523l.714-4.509h.474l-.1.652a1.383,1.383,0,0,1,1.18-.749.953.953,0,0,1,.887.5,1.878,1.878,0,0,1,.164,1.264,2.4,2.4,0,0,1-.583,1.31,1.384,1.384,0,0,1-1.046.491.929.929,0,0,1-.9-.606Zm.525-3.314-.151.954a.838.838,0,0,0,.225.629.7.7,0,0,0,.527.252.946.946,0,0,0,.662-.3,1.823,1.823,0,0,0,.43-1.039,1.574,1.574,0,0,0-.088-.981.619.619,0,0,0-.583-.348.918.918,0,0,0-.6.241,1.5,1.5,0,0,0-.424.592",
    transform: "translate(-49.756 -66.524)",
    fill: "#c7851b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M125.006,160.232h-.53l.725-4.558h.523Z",
    transform: "translate(-52.555 -65.728)",
    fill: "#c7851b"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M128.264,156.856l-.535,3.375H127.2l.535-3.375Zm.2-1.185-.092.588h-.563l.088-.588Z",
    transform: "translate(-53.707 -65.726)",
    fill: "#c7851b"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M131.831,156.791l-.063.41h-.8l-.467,2.963h-.527l.473-2.963h-.574l.065-.41h.571a1.563,1.563,0,0,1,.481-1.044,1.29,1.29,0,0,1,.767-.236,2.844,2.844,0,0,1,.472.046l-.066.419a1.2,1.2,0,0,0-.318-.044.837.837,0,0,0-.534.153.888.888,0,0,0-.253.565l-.023.141Z",
    transform: "translate(-54.832 -65.658)",
    fill: "#c7851b"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M134.6,156.856l-.537,3.375h-.523l.536-3.375Zm.2-1.185-.095.588h-.563l.1-.588Z",
    transform: "translate(-56.381 -65.726)",
    fill: "#c7851b"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M138.619,160.024l.471.1a1.781,1.781,0,0,1-1.587,1,1.188,1.188,0,0,1-1.043-.486,1.651,1.651,0,0,1-.23-1.273,2.231,2.231,0,0,1,.651-1.306,1.7,1.7,0,0,1,1.2-.5,1.142,1.142,0,0,1,.991.459,1.855,1.855,0,0,1,.194,1.37h-2.449c-.084.507-.03.856.155,1.033a.893.893,0,0,0,.636.266,1.123,1.123,0,0,0,1.014-.664M138.75,159a1.51,1.51,0,0,0-.012-.5.728.728,0,0,0-.236-.377.707.707,0,0,0-.477-.153,1.037,1.037,0,0,0-.7.278,1.394,1.394,0,0,0-.426.757Z",
    transform: "translate(-57.504 -66.524)",
    fill: "#c7851b"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M145.752,155.67l-.724,4.56h-.473l.091-.579a1.377,1.377,0,0,1-1.174.676.982.982,0,0,1-.9-.5,1.788,1.788,0,0,1-.181-1.254,2.463,2.463,0,0,1,.581-1.291,1.41,1.41,0,0,1,1.083-.518.966.966,0,0,1,.9.555l.262-1.648Zm-.921,2.491a.866.866,0,0,0-.153-.713.752.752,0,0,0-.592-.263.918.918,0,0,0-.7.345,1.9,1.9,0,0,0-.405.976,1.769,1.769,0,0,0,.068,1.03.6.6,0,0,0,.583.355,1.007,1.007,0,0,0,.695-.306,1.237,1.237,0,0,0,.4-.725Z",
    transform: "translate(-60.106 -65.726)",
    fill: "#c7851b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(32.656 41.64)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1509",
    "data-name": "Rectangle 1509",
    width: 13.874,
    height: 5.898,
    transform: "translate(-0.001)",
    fill: "#1b1818"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(61.464)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(0.001 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M118.154,41.577H109.8V4.787L106.377,0V71.008H109.8V47.478h8.355Z",
    transform: "translate(-106.378 -0.001)",
    fill: "#1b1818"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(82.499 28.215)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M143.52,48.837l-.736,12.654,2.476,5.81h1.806V53.14Z",
    transform: "translate(-142.783 -48.835)",
    fill: "#1b1818"
  }))))))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1516",
    "data-name": "Rectangle 1516",
    width: 21.771,
    height: 14.128,
    transform: "translate(24.759 28.211)",
    fill: "#daf2fd"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1517",
    "data-name": "Rectangle 1517",
    width: 21.773,
    height: 14.128,
    transform: "translate(61.461 28.211)",
    fill: "#daf2fd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.84b60dfcd32283e6ed85bf9762c223f2.svg";
export { ForwardRef as ReactComponent };